
import { Badge } from "@/components/ui/badge";

interface QuotationStatusBadgeProps {
  status: string;
}

export function QuotationStatusBadge({ status }: QuotationStatusBadgeProps) {
  const variants = {
    pending: "bg-yellow-500 hover:bg-yellow-600",
    accepted: "bg-green-500 hover:bg-green-600",
    rejected: "bg-red-500 hover:bg-red-600",
  } as const;

  const labels = {
    pending: "Pendente",
    accepted: "Aceito",
    rejected: "Rejeitado",
  } as const;

  // Use default badge style if status doesn't match known types
  const badgeStyle = variants[status as keyof typeof variants] || "bg-gray-500 hover:bg-gray-600";
  const label = labels[status as keyof typeof labels] || status;

  return (
    <span className={`px-2 py-1 rounded text-white font-medium text-sm ${badgeStyle}`}>
      {label}
    </span>
  );
}
